/** @jsx jsx */
import { jsx } from '@emotion/core';
import { gs } from '../utils';
export var Content = function (_a) {
    var children = _a.children;
    return (jsx("div", { css: {
            padding: gs(2),
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            flexGrow: 1,
        } }, children));
};
//# sourceMappingURL=Content.js.map